<template>
  <div id="js_content"
       style="display: block;">
    <div class="content_title_wrap"
         style="position:relative">
      <h1 class="content_title">微信隐私保护指引</h1>
    </div>
    <div class="content_body">
      <p>更新日期：2021年10月29日<br> 生效日期：2021年10月29日<br></p>
      <p><strong>为更充分保障你的权利，我们对《微信隐私保护指引》进行了更新，此版本的更新主要集中于：</strong></p>
      <p>1. 在第5章节“你的权利”部分，补充了部分功能，增加了个人信息浏览和导出机制，设置了系统权限和授权管理入口等。</p>
      <p>2. 在第1章节“我们收集、使用的信息”部分，更详细地披露了视频号、公众号、看一看、搜一搜个性化推荐或展示机制，并增加了个性化自主控制途径。</p>
      <p>3. 在第1章节“我们收集、使用的信息”部分，进一步披露了我们在为你提供视频号直播、互动等功能时如何处理你的个人信息，以及你享有的互动历史查阅、视频号个人信息浏览与导出等权利。</p>
      <p>4. 在第4章节“信息共享”部分，分别增加了<a href="https://weixin.qq.com/cgi-bin/readtemplate?t=ad_shared_info_list&amp;lang=zh_CN">《广告信息共享清单》</a>以进一步披露我们为优化广告效果，如何与第三方共享经去标识化或匿名化处理后的信息，以及<a href="https://weixin.qq.com/cgi-bin/readtemplate?t=3rdsdk_list&amp;lang=zh_CN">《第三方SDK目录》</a>以更充分的披露我们为确保部分独立功能的实现所接入的第三方SDK情况。</p>
      <h2 id="导言">导言</h2>
      <p>微信是一款由深圳市腾讯计算机系统有限公司（注册地为深圳市南山区粤海街道麻岭社区科技中一路腾讯大厦35层。以下亦简称“我们”或“腾讯”）提供服务的社交产品（本指引中的“微信”是与其海外运营版本即“WeChat”相区别的产品。微信与WeChat用户以手机号码区分，通过中国大陆地区手机号码进行注册的用户为微信用户，其余则为WeChat用户。本指引中所涉及的个人信息处理活动及保护均针对微信产品）。<strong>为说明微信会如何收集、使用和存储你的个人信息及你享有何种权利，我们将通过本指引向你阐述相关事宜，其中要点如下：</strong></p>
      <p>1. 我们将逐一说明我们收集的你的个人信息类型及其对应的用途，以便你了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。</p>
      <p>2. 当你使用某些功能时，我们会在获得你的同意后，收集你的敏感个人信息。如你在使用推荐通讯录朋友功能时我们会收集你的<strong>手机联系人信息</strong> ，你在使用摇一摇功能时我们会收集你的<strong>精确位置信息</strong>。除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使你无法使用相关特定功能，但不影响你正常使用微信的其他功能。</p>
      <p>3. 我们不会主动共享或转让你的个人信息至深圳市腾讯计算机系统有限公司外的第三方。如存在其他共享或转让你的个人信息，或你需要我们将你的个人信息共享或转让至深圳市腾讯计算机系统有限公司外的第三方情形时，我们会直接征得或确认第三方征得你对上述行为的明示同意，但法律法规另有规定或因保护用户权益或保护微信生态安全需要除外。此外，我们会对对外提供信息的行为进行风险评估。</p>
      <p>4. 我们不会主动从深圳市腾讯计算机系统有限公司外的第三方获取你的个人信息。如为业务发展需要从第三方获取你的个人信息，我们会依法核实来源的合法性，或在获取前向你明示你个人信息的来源、类型及使用范围，如微信开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的该等个人信息前，征得你的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。</p>
      <p>5. 你可以通过本指引所列途径及方式查阅、更正、复制、删除你的个人信息，也可以撤回同意、注销帐号、投诉举报以及设置<a href="https://ads.privacy.qq.com/ads/wxoptout.html?media_source=101001&amp;info=">个性化广告</a>等隐私功能。</p>
      <p>6. 为了在本指引下收集你的信息，或者向你提供服务、优化我们的服务以及保障你的帐号安全，我们将需要向你索取相关的权限；其中的敏感权限例如<strong>通讯录、位置、摄像头、麦克风、相册</strong>等均不会默认开启，只有在你明确同意后我们才会在你同意的范围内调用或使用。对你已经向我们授权的该等权限，<strong>你也可以在“我—设置—隐私—个人信息与权限—系统权限管理”中查询我们已调用或使用的系统权限类型、使用目的，并进行统一管理。</strong></p>
      <p>需要特别说明的是，我们获得具体某一项敏感权限并不代表我们必然会收集你的相关信息；即使我们已经获得敏感权限，也仅在必要范围内，并在你使用相关的服务或功能期间根据本指引来收集你的相关信息。</p>
      <p>如你想了解更加详尽的信息，请根据以下索引阅读相应章节：</p>
      <p><a href="#1%E6%88%91%E4%BB%AC%E6%94%B6%E9%9B%86%E3%80%81%E4%BD%BF%E7%94%A8%E7%9A%84%E4%BF%A1%E6%81%AF">1. 我们收集、使用的信息</a></p>
      <p><a href="#2%E4%BF%A1%E6%81%AF%E7%9A%84%E5%AD%98%E5%82%A8">2. 信息的存储</a></p>
      <p><a href="#3%E4%BF%A1%E6%81%AF%E5%AE%89%E5%85%A8">3. 信息安全</a></p>
      <p><a href="#4%E4%BF%A1%E6%81%AF%E5%85%B1%E4%BA%AB">4. 信息共享</a></p>
      <p><a href="#5%E4%BD%A0%E7%9A%84%E6%9D%83%E5%88%A9">5. 你的权利</a></p>
      <p><a href="#6%E5%8F%98%E6%9B%B4">6. 变更</a></p>
      <p><a href="#7%E6%9C%AA%E6%88%90%E5%B9%B4%E4%BA%BA%E4%BF%9D%E6%8A%A4">7. 未成年人保护</a></p>
      <p><a href="#8%E5%85%B6%E4%BB%96">8. 其它</a></p>
      <p><a href="#9%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC">9. 联系我们</a></p>
      <h2 id="1我们收集、使用的信息">1.我们收集、使用的信息</h2>
      <p>在你使用微信服务的过程中，我们会按照如下方式收集、使用你在使用服务时主动提供或因为使用服务而产生的信息：</p>
      <p>1.1 当你注册微信服务时，我们会收集、使用你的昵称、头像、手机号码，收集这些信息是为了帮助你完成微信注册和使用微信社交等功能，保护你微信帐号的安全。收集、使用手机号码是为了满足相关法律法规的真实身份信息认证要求。若你不提供这类信息，你可能无法正常使用我们的服务。你还可以根据自身需求选择填写性别、地区等信息。此外，你可以选择向我们提供你的<strong>声纹特征值信息</strong>以使用声音锁功能，该信息属于敏感个人信息，拒绝提供该信息仅会使你无法使用声音锁功能，但不影响你正常使用微信的其他功能。</p>
      <p>1.2 当你使用微信服务时，为保障你正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障你的帐号安全，我们会收集、使用你的设备型号、操作系统、<a href="https://privacy.qq.com/document/priview/896637b6dc4f4b80b48163580d63e07e">唯一设备标识符</a>（指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备）、登录IP地址、微信软件版本号、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息（如你在微信进行搜索、查看操作的记录、服务故障信息、引荐网址等信息）等日志信息。</p>
      <p>1.3 当你使用微信朋友圈功能时，为了让你的好友可以浏览你分享的内容，我们会收集、使用并按照你设定的规则展示你发布的朋友圈文字、照片、视频、<strong>位置信息</strong>、评论、点赞、朋友圈封面等信息。你也可以随时删除你的上述朋友圈信息。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述朋友圈信息，或者将其用于该功能以外的其他用途。你可以在“设置”—“隐私” —“朋友圈”中设置朋友圈内容的可见范围。</p>
      <p>1.4 当你使用微信公众帐号（含订阅号、服务号，以下亦简称“公众号”）时，为了更好地为你提供相关服务（包括基于系统和信息安全、虚假消息鉴别等），以及在“订阅号消息”页面的推荐功能里为了向你提供更加便捷、优质和个性化的服务和内容，我们会收集、使用你的公众号关注、取消关注、互动记录，以及公众号信息内容阅读、观看、收藏、推荐、分享及微信内浮窗管理（加入浮窗/移出浮窗/关闭浮窗）等操作记录。你可以通过点击“订阅号消息”页面右上角的标识进入订阅号列表，点击“订阅号列表”页面右上角“…”—点击页面底部“设置”—点击“订阅号消息个性化推荐”，自行选择关闭订阅号消息中推荐功能的个性化内容推荐服务。</p>
      <p>当你使用订阅号功能时，为了更合理地向你展示你所关注的公众号发布的文章，我们还会使用你的订阅号信息内容阅读、观看等操作记录，对文章进行更优化的排序展示。你也可以通过点击“订阅号消息”页面右上角的标识，进入订阅号列表，切换为根据文章发布时间先后进行排序展示。</p>
      <p>若公众号主体在向你提供服务时需通过微信获取你的个人信息，我们会在征得你的明示同意后，向公众号主体提供你的个人信息，具体提供范围以交互页面中你同意的为准。你也可以在公众号的设置页管理相关信息，如关闭提供你的<strong>位置信息</strong>等。</p>
      <p>1.5 当你使用微信小程序时，为了更好地为你提供相关服务（包括基于系统和信息安全等），微信会收集、使用你的微信小程序登录、浏览、使用、添加到/移除出“我的小程序”、微信内浮窗管理（加入浮窗/移出浮窗/关闭浮窗）等操作记录。</p>
      <p>若开发者在向你提供微信小程序服务时，需通过微信获取你的个人信息，我们会在征得你的明示同意后，向开发者提供你的个人信息或可获取你个人信息的微信接口，具体提供范围以交互页面中你同意的为准。你也可以在小程序设置页管理已通过微信提供至开发者的信息或接口，我们会根据你的指示协助通知开发者删除你的个人信息或在你关闭相应接口后，停止通过该接口向开发者提供你的个人信息。</p>
      <p>1.6 当你使用微信附近的人、摇一摇、雷达加好友、面对面建群以及附近的小程序等功能时，我们会在获得你的自主选择同意后，记录你的<strong>位置信息</strong>，目的是为了向你提供该服务。拒绝提供该信息仅会使你无法使用上述功能，但不影响你正常使用微信的其他功能。</p>
      <p>1.7 当你使用微信运动功能时，我们需要收集并展示你的步数信息，并与你的好友进行比较、点赞互动。拒绝提供这些信息仅会使你无法使用微信运动功能，但不影响你正常使用微信的其他功能。</p>
      <p>1.8 当你使用微信看一看（包括“朋友在看”“热点广场”）功能时，为了向你提供更加便捷、优质和个性化的服务和内容，我们会使用你的公众号、视频号关注、访问、互动，以及内容阅读、播放、点赞、分享、在看、评论等操作记录。你也可以通过点击“看一看”—右上角“个人中心”—页面底部“隐私设置”—“个性化推荐”开关，自行关闭个性化内容推荐服务。当你使用看一看（热点广场）功能时，为了向你提供更精准的位置相关推荐内容，我们会在获得你的自主选择同意后，<strong>收集你的位置信息。</strong></p>
      <p>1.9 当你在微信使用搜索能力（包括搜一搜、公众号搜索、扫一扫、指尖搜索、图片搜索、小程序搜索等）时，为了向你展示更精准的位置相关搜索结果，我们会在获得你的自主选择同意后，<strong>收集你的位置信息</strong> 。拒绝提供该信息可能会使你无法使用上述功能，或无法达到上述基于位置信息提供的相关服务拟达到的效果，但不影响你正常使用微信的其他功能。同时，为了向你展示更精准匹配的搜索结果，我们会使用你的搜索记录、小程序访问记录、公众号关注，以及公众号文章阅读、收藏、分享、在看等操作记录，你也可以通过点击“发现”—“搜一搜”—页面底部“隐私设置”—“个性化搜索结果展示”开关，自行关闭个性化搜索结果展示服务。</p>
      <p>1.10 当你使用微信语音输入、语音与文字间转换、对聊天内容（包括文字信息和图片）使用搜一搜功能以及使用微信内翻译功能（包括翻译聊天、朋友圈文字信息及翻译图片中的文字，以及使用边写边译功能）、扫一扫功能时，我们会收集你的语音内容、待转换的语音或文字信息、待搜索的信息、待翻译的信息和扫描的内容，收集是为实现上述功能所必需的。我们实时处理之后，向你返回处理结果，不会保存你的数据。</p>
      <p>1.11 当你在微信内充值、使用微信豆的，我们会收集你的充值<strong>订单信息、使用记录</strong>，这是为你提供该功能所必需的。如需了解微信豆的更多信息，你可以进一步查阅<a href="https://weixin.qq.com/cgi-bin/readtemplate?t=wxbean&amp;lang=zh_CN">《微信豆及相关功能使用条款》</a>。</p>
      <p>1.12 微信支付功能由财付通支付科技有限公司（以下亦简称“财付通公司”）向你提供服务。当你开通微信支付功能时，<strong>财付通公司会收集你的姓名、身份证号码或其他合法身份证明文件号码、银行卡类型及卡号、有效期及银行预留手机号</strong>；当你使用微信支付时， <strong>财付通公司还会收集你的相关交易订单、支付记录以便于你查询</strong>。拒绝提供该信息仅会使你无法使用微信支付功能，但不影响你正常使用微信的其他功能。如需进一步了解微信支付功能的隐私政策，你可以进一步查阅<a href="https://www.tenpay.com/v3/helpcenter/low/privacy.shtml">《财付通隐私政策》</a>。</p>
      <p>1.13 当你添加企业微信好友，加入企业微信互通群或使用其他企业微信互通功能时，你的企业微信好友所在的企业主体（“企业微信用户”）可能会收集以下信息：包括你的昵称、头像等帐号信息，你和企业微信好友之间的聊天记录以及其他你主动向企业微信用户披露的数据信息。<strong>你在选择使用企业微信互通服务时，可通过产品交互提示或企业用户展示的数据保护政策了解你的权益。你可以拒绝使用该等互通服务，但不影响你正常使用微信的其他功能</strong>。如需进一步了解企业微信的隐私政策，你可以进一步查阅<a href="https://work.weixin.qq.com/nl/privacy">《企业微信隐私保护指引》</a>。</p>
      <p>1.14 当你使用微信与其他软件或硬件互通功能时，其他软件或硬件的提供方在经你同意后可以获取你在微信主动提供、公开或传输的相关信息，你在选择前应充分了解其他软件或硬件的产品功能及个人信息处理规则。</p>
      <p>1.15 当你使用微信视频号浏览视频内容和直播内容时，为了优化你的使用体验、让你获得个性化的内容，我们会使用你的关注、点赞、收藏（星标）、互动、搜索、浏览及转发分享的记录。你可以在“浏览设置”中点击“隐私”选项，点击“个性化推荐”分别对视频内容或直播内容关闭个性化内容推荐。</p>
      <p>为实现向你推荐本地内容或推荐同城直播等目的，我们会在获得你的自主选择同意后，<strong>收集你的位置信息</strong>进行相关推荐。当你使用微信视频号功能时若你不同意或取消授权，与位置信息相关的功能可能无法使用，但不会影响你使用其他功能。</p>
      <p>你点赞的视频内容也将被推荐给你的微信好友，你可以取消点赞，取消后不会再推荐给你的微信好友。你也可以取消关注的视频号及收藏（星标）的视频内容。当你使用直播预约功能时，我们将会收集你的预约记录，以提醒你及时观看直播，你可以取消预约。</p>
      <p>1.16 <strong>当你评论、私信、点赞或关注视频号用户，以及你正在观看或打赏视频号用户的直播时，你的微信个人名片会向该视频号用户展示，你的头像、昵称、及评论还会向其他用户展示。</strong> 你可以选择用微信号身份或视频号身份或设置一个新身份观看直播或私信互动，也可以设置你不看的视频号，不看部分微信好友点赞的内容，或不让部分微信好友看自己点赞的内容。<strong>你可以进入“互动历史”选项查阅你关注、点赞、收藏（星标）的视频内容以及消息和私信。</strong></p>
      <p>1.17 当你创建微信视频号帐号并发布内容，你设置的视频号名字、头像、性别、地区、简介、封面、认证信息、黑名单帐号、绑定的公众号或企业微信，你发布的视频、直播内容、图片、文字、<strong>位置</strong>、链接，以及与你有关的评论、互动、消息通知等信息将被收集，同时，当你发布视频内容或直播内容，我们会根据你希望使用的功能依场景请求你授权相应功能所需的<strong>相机、照片、麦克风或位置权限</strong>，若你不同意或取消授权，将无法使用相应功能，但不影响你使用微信其他功能。你可以更改你的视频号的名字、头像、性别、简介、封面、黑名单帐号等信息，设置为私密帐号，删除你发表的动态。在视频号的设置页面，你可以选择在微信个人名片中展示你的视频号内容，你也可以选择关闭展示。</p>
      <p>1.18 当你发表视频内容、直播内容、绑定公众号时，根据相关法律法规以及校验身份的需要，你需要进行<strong>实名认证</strong>。<strong>实名认证</strong>服务由财付通公司提供。如果拒绝<strong>实名认证</strong>，你将可能无法获得相关服务，但不影响其他功能的正常使用。此外，<strong>为保障帐号安全，我们可能需要你填写你的真实姓名、身份证号码并通过“人脸识别”的方式进行校验以确认是你本人操作，我们仅获得校验的结果，不会保留相关信息，除非腾讯依照法律法规规定另行取得你的同意。上述信息包含敏感个人信息，你可以拒绝提供，如果拒绝提供你将可能无法获得相关服务，但不影响其他功能的正常使用。你发表的视频内容、直播内容若标记了位置信息，将会被推荐给该位置附近的已授权位置权限的用户、同城用户等。</strong></p>
      <p>1.19 当你对视频号帐号进行帐号认证、管理直播收入、与机构用户进行绑定、参加直播任务或者参加我们主办的各类活动，可能会涉及对你的信息进行处理，我们将在相关场景向你另行告知相应的规则并征得你的同意。当你使用视频号进行游戏直播或小游戏直播时，我们还会按照<a href="https://weixin.qq.com/cgi-bin/readtemplate?t=finder_live_game_agreement&amp;lang=zh_CN">《微信视频号游戏直播须知》</a>处理你的信息。</p>
      <p>1.20 你可以在你的视频号主页进入“隐私设置”，选择“个人信息浏览与导出”，以对你的帐号信息、认证信息等进行查阅，并按照指引导出相关信息。</p>
      <p>1.21 当你授权微信游戏（微信游戏是指微信为用户提供的游戏相关服务与功能，包括“发现—游戏”模块，“小游戏”类目的小程序，以及“微信游戏”公众号）使用你的游戏账号信息（包括登录信息、角色信息、对局数据）、游戏好友关系的，我们将在微信游戏的好友排行、战绩服务、游戏社区、内容与服务推荐等场景使用该等信息，<strong>你可以选择该等信息的可见范围，也可以选择不向好友展示这些信息，不展示并不影响你正常使用腾讯游戏、微信游戏和微信的其他功能</strong>。</p>
      <p>1.22 当你使用“小游戏”类目的小程序（下亦简称“小游戏”）时，为了更好地为你提供相关服务，微信会使用你的小游戏登录、浏览、添加到/移除出“我的小程序”、 微信内浮窗管理（加入浮窗/移出浮窗/关闭浮窗）等操作记录。<strong>我们会在微信游戏相关界面向你的好友展示你玩过的小游戏、你的头像和昵称等。你可以选择不向好友展示这些信息，不展示并不影响你正常使用小游戏和微信的其他功能。</strong></p>
      <p>1.23 你可以在微信游戏设置你的微信游戏名片。设置微信游戏名片的过程中，我们会收集你为此功能所主动填写/设置的头像、昵称、生活照、签名、性别、生日、<strong>地区（此处会向你申请获取你的位置以快速展示你所在地区，你也可以拒绝授权从而不展示地区）等信息</strong>。</p>
      <p>当你成功设置后，你所填写/设置的前述信息将仅用于微信游戏内的微信游戏名片功能，以便你更好地与其他用户互动（其他用户将可通过微信游戏名片来关注你或通过 “打招呼”功能与你互动）及获得个性化的游戏礼包（如生日礼包）；且该等信息不会被用于其他场景，也不会被用于判定微信账号的使用权权属与真实身份信息认证等。<strong>你可以选择不设置你的微信游戏名片，这不会影响你正常使用微信游戏中心、腾讯游戏、小游戏的其他功能。</strong></p>
      <p>1.24 <strong>当你使用状态功能时，我们会收集你发表的内容、自主选择的状态图标与位置等信息，以向其他用户展示，这是实现这一功能所必需的。我们会在具体状态信息的展示期内（状态展示有效期请见状态设置界面中的提示），根据你公开与否的选择，对该等信息进行相应的展示，你也可以随时删除状态以删除这些信息。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述状态信息，或者将其用于该功能以外的其他用途。</strong></p>
      <p>1.25 当你使用微信的收藏功能来储存各类信息时，该等信息将被上传并存储在我们的服务器中，以便你在其他设备上登录微信时使用该等信息，这是实现收藏功能所必需的。我们会对你收藏的信息以加密的方式存储，你也可以随时删除自己所收藏的信息。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，或者将其用于该功能以外的其他用途。</p>
      <p>1.26 当你使用卡包功能时，为向你推荐附近与卡券关联的本地服务或便于你使用所在城市的公交卡服务，我们会在获得你的同意后，收集你的<strong>位置信息</strong>。拒绝提供该信息可能会使你无法使用上述功能，或无法达到上述基于位置信息提供的相关服务拟达到的效果，但不影响你正常使用微信的其他功能。</p>
      <p>1.27 你可以在你的个人信息栏中填写性别、<strong>地区</strong>、个性签名、<strong>地址</strong>等，这些信息将被上传并存储在我们的服务器中，以便你在其他设备上登录微信时使用该等信息。你也可以随时修改、删除该等信息。</p>
      <p>1.28 当你使用微信群聊功能时，群聊名称、群公告、群成员昵称、群设置、备注、你设置的聊天背景图等信息会存储在我们的服务器中，这是实现这一功能所必需的。你的头像、昵称等还会向群成员展示。</p>
      <p>1.29 <strong>我们不会收集你的聊天记录。你在微信中的聊天记录会存储在你的终端设备，你可以选择自行备份、删除或在不同设备中转移。</strong></p>
      <p>1.30 微信服务中的第三方服务由外部第三方主体提供，微信无法获得你在使用该类第三方服务时产生的信息。但是，如果你已明示同意该第三方获得你的<strong>位置信息</strong>，该第三方将通过微信接口获得相关信息。拒绝提供该信息仅会使你无法使用上述第三方服务，但不影响你正常使用微信的功能。</p>
      <p>1.31 如果你联系我们的客服，我们可能需要你提供必要的个人信息进行身份验证，以保证你的帐号安全。为根据你的诉求提供服务，经过你的授权，人工客服人员需要在你授权范围内查询或核验你的相关信息，我们将尽可能采取技术和管理措施保障你的信息安全和保密，并在必要范围内进行使用。<strong>我们可能还会保存你的联系方式（你使用的或主动提供的手机号码、微信号、QQ号或其他联系方式）、你与我们的通信记录和内容，以及其他必要信息，以便为你提供和记录客户服务</strong>。</p>
      <p>1.32 <strong>另外，根据相关法律法规及国家标准，以下情形中，我们可能会处理你的相关个人信息而无需征求你的授权同意：</strong></p>
      <p><strong>a)为个人信息处理者履行法定义务或法定职责所必需；</strong></p>
      <p><strong>b)为订立、履行你作为一方当事人的合同所必需；</strong></p>
      <p><strong>c)为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</strong></p>
      <p><strong>d)依法在合理的范围内处理你自行公开或者其他已经合法公开的个人信息；</strong></p>
      <p><strong>e)法律、行政法规规定的其他情形。</strong></p>
      <p>1.33 请你理解，我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中告知收集、使用你的信息的处理规则，我们会通过页面提示、交互流程、网站公告等方式另行向你告知信息收集的范围、目的及方式，以征得你的同意。</p>
      <p>1.34 <strong>我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你或你的好友提供特定内容，包括但不限于展示广告（你可以通过“我—设置—隐私—个人信息与权限—个性化广告管理”管理微信为你提供的<a href="https://ads.privacy.qq.com/ads/wxoptout.html?media_source=101001&amp;info=">个性化广告</a>），对你阅读过的内容进行信息安全类提示，基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容，以及保护用户权益或保护微信生态安全等</strong> 。</p>
      <p>1.35 为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息融合处理。</p>
      <p>1.36 如我们使用你的个人信息，超出了你所授权的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。</p>
      <p>1.37 请你注意，目前微信不会主动从深圳市腾讯计算机系统有限公司外的第三方获取你的个人信息。如未来为业务发展需要从第三方间接获取你个人信息，我们会在获取前向你明示你个人信息的来源、类型及使用范围，如微信开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的该等个人信息前，征得你的明示同意。</p>
      <p>此外，我们将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。</p>
      <h2 id="2信息的存储">2.信息的存储</h2>
      <p><strong>2.1 信息存储的地点</strong></p>
      <p><strong>我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内</strong>。如果你的个人信息存储地点从中国境内转移到境外的，我们将严格依照法律的规定执行。</p>
      <p><strong>2.2 信息存储的期限</strong></p>
      <p>一般而言，我们仅在为实现目的所必需的时间及法律、行政法规所规定的保存期限内保留你的个人信息，例如：</p>
      <p>手机号码：无论你是通过手机号码注册还是已有微信帐号辅助注册新微信帐号，若你需要使用微信服务，我们需要一直保存你的手机号码（包括初始注册手机号码、绑定的手机号码等），以保证你正常使用该服务。当你注销微信帐号后，我们将依法删除相应的信息；</p>
      <p>朋友圈信息：当你发送了朋友圈信息，我们需要保存你的朋友圈信息，以保证你正常使用朋友圈功能，当你删除你的朋友圈信息后，我们将删除相应的信息。</p>
      <p>当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，并在合理的期限内删除你的个人信息或进行匿名化处理。（本指引中的“匿名化处理”，是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。）</p>
      <h2 id="3信息安全">3.信息安全</h2>
      <p>我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、篡改、未经授权访问或披露。</p>
      <p>我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL）、去标识化、匿名化处理等手段来保护你的个人信息。</p>
      <p>我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、网站，我们可能会了解你设备安装的应用信息、正在运行的进程信息或设备内存中寄存的数据；为了预防诈骗、盗号、仿冒他人等不法行为和进行安全检查可能会分析利用唯一设备标识符、登录IP地址、操作日志、<strong>位置信息</strong>等数据，以便于采取安全措施或进行安全提醒等。</p>
      <p>我们建立专门的管理制度、操作规程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。此外，腾讯还会设立主要由外部成员组成的独立机构对我们的个人信息保护情况进行监督。</p>
      <p>若发生个人信息泄露等安全事件，我们会启动应急预案及补救措施，阻止安全事件扩大，并依法履行相关的报告及通知义务。</p>
      <p>目前，微信通过了国家网络安全等级保护（三级）的定级、备案及年度测评，在信息安全方面已达到ISO27001、国际信息安全管理体系、TRUSTArc等国际权威认证标准的要求，并已获得了相应的认证。</p>
      <p>我们会尽力保护你的个人信息。<strong>我们也请你理解，任何安全措施都无法做到无懈可击</strong>。</p>
      <h2 id="4信息共享">4.信息共享</h2>
      <p>4.1 为了投放广告，评估、优化广告投放效果等目的，我们需要向广告主及其代理商等第三方合作伙伴共享你的部分数据，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。具体可见<a href="https://weixin.qq.com/cgi-bin/readtemplate?t=ad_shared_info_list&amp;lang=zh_CN">《广告信息共享清单》</a>。</p>
      <p>4.2 我们不会向合作伙伴分享可用于识别你个人身份的信息，除非你明确授权。</p>
      <p>4.3 当你在第三方主体运营的网站或者应用中使用微信登录功能时，我们将向该等第三方主体提供你的个人信息，具体的对外提供范围以交互页面中你确认的为准。除此之外，在未征得你的明示同意前，我们不会向该等第三方主体提供你的个人信息。<strong>你可以通过“我—设置—隐私—个人信息与权限—授权管理”查看你已授权的应用清单，并管理、解除你授权的信息。</strong></p>
      <p>4.4 为确保部分独立功能的实现，使你能够使用和享受更多的服务及功能，我们会在应用中嵌入第三方的SDK，我们将审慎评估该等SDK的使用目的。了解更多有关SDK处理个人信息的目的、方式及范围等信息，请点击<a href="https://weixin.qq.com/cgi-bin/readtemplate?t=3rdsdk_list&amp;lang=zh_CN">《第三方SDK目录》</a>。</p>
      <p>随着我们业务的持续发展，我们有可能进行合并、分立等交易，若涉及个人信息转移的，我们将告知你相关情形，按照法律法规及不低于本指引所要求的标准继续保护或要求新的处理者继续保护你的个人信息。</p>
      <h2 id="5你的权利">5.你的权利</h2>
      <p>在你使用微信期间，为了你可以更加便捷地查阅、复制、更正、删除你的个人信息，同时保障你撤回对个人信息处理的同意及注销帐号的权利，我们在产品设计中为你提供了相应的操作设置，你可以参考下面的指引进行操作。此外，我们还设置了投诉举报、请求解释的渠道，你的意见及请求将会得到及时的处理。</p>
      <p><strong>请注意，不同操作系统、微信软件的不同版本之间，操作设置可能存在差异</strong>；此外，为了优化你的使用体验，我们也可能对操作设置进行调整。故如下指引仅供参考，若你对行使相关权利的方式及途径仍有任何疑问的，你可以通过本规则第9条披露的方式与我们联系。</p>
      <p><strong>5.1 查阅、复制个人信息</strong></p>
      <p><strong>5.1.1 查阅头像、昵称（即“名字”，下同）、拍一拍、微信号、二维码、性别、地区、个性签名、我的地址等基本信息：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击头像栏；<br> 3) 进行信息查询访问。<br></p>
      <p><strong>5.1.2 查阅微信号、手机号、微信密码、声音锁、应急联系人、登录设备管理、更多安全设置（QQ号、邮箱地址）：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“帐号与安全”；<br> 4) 进行信息查询访问。<br></p>
      <p><strong>5.1.3 查阅朋友圈信息、状态信息：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“朋友圈”；<br> 3) 点击“我的朋友圈”以访问朋友圈信息，或点击“状态”访问状态信息。<br></p>
      <p><strong>5.1.4 查阅及设置微信游戏隐私及授权、订阅等：</strong></p>
      <p>1) 进入微信后，点击“发现”；<br> 2) 点击“游戏”；<br> 3) 点击头像；<br> 4) 点击设置图标；<br> 5) 点击“新消息通知”“订阅管理”“隐私”“按游戏管理”等进行相应访问和设置。<br></p>
      <p><strong>5.1.5 查阅通讯录黑名单：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 点击“通讯录黑名单”进行查询。<br></p>
      <p><strong>5.1.6 查阅在视频号的互动信息：</strong></p>
      <p>1) 进入微信后，点击“发现”；<br> 2) 点击“视频号”；<br> 3) 点击右上角人形图标；<br> 4) 点击“隐私”；<br> 5) 点击“互动历史”。<br></p>
      <p><strong>5.1.7 查阅及导出视频号帐号个人信息：</strong></p>
      <p>1) 进入微信后，点击“发现”；<br> 2) 点击“视频号”；<br> 3) 点击右上角人形图标；<br> 4) 点击视频号头像名字一栏，进入视频号主页；<br> 5) 点击右上角“...”，进入设置页；<br> 6) 点击“隐私设置”；<br> 7) 点击“个人信息浏览与导出”。<br></p>
      <p><strong>5.1.8 查阅与复制个人信息：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 点击“个人信息与权限”<br> 5) 点击“个人信息”以查阅你的个人信息；<br> 6) 点击“导出个人信息”，以复制一份个人信息副本并发送到你指定的邮箱。<br></p>
      <p><strong>5.2 删除个人信息</strong></p>
      <p><strong>5.2.1 删除一对一全部聊天记录：</strong></p>
      <p>1) 进入微信后，打开对话，点击右上角“…”图标；<br> 2) 点击清空聊天记录。<br></p>
      <p><strong>5.2.2 删除群聊天记录：</strong></p>
      <p>1) 进入微信后，打开对话，点击右上角“…”图标；<br> 2) 点击清空聊天记录。<br></p>
      <p><strong>5.2.3 删除部分/全部聊天记录：</strong></p>
      <p>1) 进入微信后，打开对话，长按点击一条需要删除的消息；<br> 2) 选择“删除”，删除此条消息；<br> 3) 进入微信后，点击“我”；<br> 4) 点击“设置”；<br> 5) 点击“通用”（或“聊天”）；<br> 6) 点击清空聊天记录，删除全部聊天记录。<br></p>
      <p><strong>5.2.4 删除个性签名、我的地址等基本信息（二维码无法修改或删除）：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击头像栏；<br> 3) 删除相关信息。<br></p>
      <p><strong>5.2.5 删除朋友圈：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“朋友圈”；<br> 3) 点击“我的朋友圈”；<br> 4) 点击需要访问的朋友圈信息；<br> 5) 点击右上角“…”，并删除朋友圈信息。<br></p>
      <p><strong>5.2.6 删除视频号内容：</strong></p>
      <p>1) 进入微信后，按照5.1.7的操作进入视频号主页；<br> 2) 点击要删除的内容<br> 3) 点击右上角“...”<br> 4) 点击删除。<br></p>
      <p><strong>5.2.7 删除收藏内容：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“收藏”；<br> 3) 点击要删除的内容；<br> 4) 点击右上角“...”<br> 5) 点击删除。<br></p>
      <p><strong>5.2.8 删除登录设备：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“帐号与安全”；<br> 4) 点击“登录设备管理”；<br> 5) 点击“编辑”可删除相应登录设备。<br></p>
      <p><strong>5.3 更正个人信息</strong></p>
      <p><strong>5.3.1 更改头像、昵称、拍一拍、性别、地区、个性签名、我的地址：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击头像栏；<br> 3) 进行更正操作。<br></p>
      <p><strong>5.3.2 更改手机号、微信密码、声音锁、应急联系人：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“帐号与安全”；<br> 4) 进行更正操作。<br></p>
      <p><strong>5.3.3 更改视频号头像、名称、简介：</strong></p>
      <p>1) 进入微信后，按照5.1.7的操作进入视频号主页；<br> 2) 点击右上角“…”；<br> 3) 点击头像、名字一栏进入资料页进行更改。<br></p>
      <p><strong>5.4 功能及权限管理</strong></p>
      <p><strong>5.4.1 关闭推荐通讯录朋友：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 可关闭“向我推荐通讯录朋友”。<br></p>
      <p><strong>5.4.2 关闭附近的人设置：</strong></p>
      <p>1) 进入微信后，点击“发现”；<br> 2) 点击“直播和附近”；<br> 3) 点击“附近的人”，点击“确定”可打开该功能；<br> 4) 打开后，点击右上角“…”；<br> 5) 点击“清除位置信息并退出”可关闭该功能。<br></p>
      <p><strong>5.4.3 关闭微信运动：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“通用”；<br> 4) 点击“辅助功能”；<br> 5) 点击“微信运动”；<br> 6) 点击“停用”；<br> 7) 点击“清空并停用”。<br></p>
      <p><strong>5.4.4 关闭摇一摇：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“通用”；<br> 4) 点击“发现页管理”；<br> 5) 关闭“摇一摇”。<br></p>
      <p><strong>5.4.5 解除向其他应用的授权：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 点击“个人信息与权限”；<br> 5) 点击“授权管理”；<br> 6) 点击需要管理的授权内容；<br> 7) 点击“解除授权”。<br></p>
      <p><strong>5.4.6 系统权限管理：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 点击“个人信息与权限”；<br> 5) 点击“系统权限管理”；<br> 6) 点击“前往系统设置更多”。<br></p>
      <p><strong>5.5 注销帐号</strong></p>
      <p><strong>5.5.1 注销微信帐号：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“帐号与安全”；<br> 4) 点击“微信安全中心”；<br> 5) 点击“注销帐号”。<br></p>
      <p>注：当你注销帐号后，我们将按照《中华人民共和国网络安全法》等法律法规的规定留存你的相关信息；超出必要保存期限后，我们将删除或匿名化处理你的个人信息。</p>
      <p><strong>5.5.2 注销微信支付：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“支付”；<br> 3) 点击右上角“… ”；<br> 4) 点击“注销微信支付”。<br></p>
      <p><strong>5.6 投诉举报</strong></p>
      <p>1)进入微信后，点击“我”；<br> 2)点击“设置”；<br> 3)点击“关于微信”；<br> 4)点击“投诉”。<br></p>
      <p><strong>5.7 隐私功能设置</strong></p>
      <p><strong>5.7.1 设置添加好友时是否需要验证：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 点击“加我为朋友时需要验证”进行更改。<br></p>
      <p><strong>5.7.2 设置用户被添加的方式：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 点击“添加我的方式”进行更改。<br></p>
      <p><strong>5.7.3 设置朋友圈入口：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“通用”；<br> 4) 点击“发现页管理”；<br> 5) 打开/关闭朋友圈入口。<br></p>
      <p><strong>5.7.4 查看朋友圈的公开范围</strong> <strong>：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“隐私”；<br> 4) 点击“朋友圈”；<br> 5) 可设置“允许朋友查看朋友圈的范围”；<br> 6) 可设置是否“允许陌生人查看十条朋友圈”。<br></p>
      <p><strong>5.7.5 设置朋友权限范围：</strong></p>
      <p>1) 进入通讯录后，选择需要设置的好友；<br> 2) 选中好友后，单击右上角“…”；<br> 3) 点击“朋友权限”；<br> 4) 对“朋友权限”进行设置。<br></p>
      <p><strong>5.7.6 设置发送朋友圈时的位置及公开范围：</strong></p>
      <p>1) 进入微信后，点击“发现”；<br> 2) 点击朋友圈；<br> 3) 长按右上角“相机”图标；<br> 4)可选择“所在位置”“谁可以看”“提醒谁看”等内容。<br></p>
      <p><strong>5.7.7 设置视频号的黑名单、私密帐号：</strong></p>
      <p>1) 进入微信后，点击“发现”；<br> 2) 点击“视频号”；<br> 3) 点击右上角人形图标；<br> 4) 点击头像；<br> 5) 点击“…”；<br> 6) 点击“隐私设置”；<br></p>
      <p><strong>5.7.8 设置视频号的朋友点赞、观看身份：</strong></p>
      <p>1) 进入微信后，点击“发现”；<br> 2) 点击“视频号”；<br> 3) 点击右上角人形图标；<br> 4) 点击“隐私”。<br></p>
      <p><strong>5.7.9 选择使用不同的个人信息登录微信以外的网站或者应用：</strong></p>
      <p>1) 在允许使用微信个人帐号进行登录的网站或者应用中，点击“微信登录”或者其他指代该意义的图标（通常是微信图标）；<br> 2) 选择不同的个人信息（头像、昵称），或者新建用户信息（头像、昵称），来作为登录该等网站或者应用的头像和昵称。<br></p>
      <p><strong>5.7.10 微信运动隐私设置：</strong></p>
      <p>1) 进入微信后，点击“我”；<br> 2) 点击“设置”；<br> 3) 点击“通用”；<br> 4) 点击“辅助功能”；<br> 5) 点击“微信运动”；<br> 6) 点击“隐私及提醒设置”；<br> 7) 对微信运动进行隐私设置。<br></p>
      <p>此外，你也可以在“微信运动”页面点击“停用”，以清空历史数据并停用微信运动功能。</p>
      <p><strong>5.8 逝者近亲属的权利</strong></p>
      <p>如微信用户不幸逝世，其近亲属可通过腾讯客服官方渠道联系我们，以获取相关指引来行使法律规定的合法、正当权益。</p>
      <h2 id="6变更">6.变更</h2>
      <p>我们可能会适时对本指引进行修订。当指引的条款发生重大变更时，我们会在你登录及版本更新时以推送通知、弹窗或其他符合法律要求的适当形式向你展示变更后的指引。</p>
      <h2 id="7未成年人保护">7.未成年人保护</h2>
      <p><strong>我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若你是18周岁以下的未成年人，在使用微信服务前，应事先取得你的家长或法定监护人的书面同意。若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过第9章中的联系方式与我们联系。</strong></p>
      <p><strong>特别地，若你是14周岁以下的儿童，我们还专门为你制定了<a href="https://privacy.qq.com/privacy-children.htm">《儿童隐私保护声明》</a> ，儿童及其监护人在为14周岁以下的儿童完成帐号注册前，还应仔细阅读腾讯公司专门制定的<a href="https://privacy.qq.com/privacy-children.htm">《儿童隐私保护声明》</a> 。只有在取得监护人对<a href="https://privacy.qq.com/privacy-children.htm">《儿童隐私保护声明》</a>的同意后，14周岁以下的儿童方可使用微信服务。</strong></p>
      <h2 id="8其他">8.其他</h2>
      <p>8.1 腾讯<a href="https://privacy.qq.com/policy/tencent-privacypolicy">《隐私政策》</a>是腾讯统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于微信用户。如腾讯<a href="https://privacy.qq.com/policy/tencent-privacypolicy">《隐私政策》</a>与本指引存在不一致或矛盾之处，请以本指引为准。</p>
      <p>8.2 在微信某些具体服务或功能项下，我们可能还会通过交互文案、产品界面或弹窗等方式向你另行告知处理个人信息的目的、方式或范围，若另行告知的内容与本指引不一致的，以另行告知的内容为准。</p>
      <p>8.3 <a href="https://privacy.qq.com/privacy-children.htm">《儿童隐私保护声明》</a>是适用于14周岁以下的儿童用户的信息保护规则。在<a href="https://privacy.qq.com/privacy-children.htm">《儿童隐私保护声明》</a>的适用范围内，如其与腾讯<a href="https://privacy.qq.com/policy/tencent-privacypolicy">《隐私政策》</a>、本指引存在不一致或矛盾之处，请以<a href="https://privacy.qq.com/privacy-children.htm">《儿童隐私保护声明》</a>为准。</p>
      <h2 id="9联系我们">9.联系我们</h2>
      <p>我们设立了专门的个人信息保护团队和个人信息保护负责人，如果你对本隐私政策或个人信息保护相关事宜有任何疑问或投诉、建议时，你可以通过以下任一方式与我们联系：</p>
      <p>1) 通过<a href="https://kf.qq.com/">https://kf.qq.com/</a>与我们联系；<br> 2) 将你的问题发送至Dataprivacy@tencent.com；<br> 3) 寄到如下地址：中国广东省深圳市南山区科技中一路腾讯大厦 法务部 数据及隐私保护中心（收），邮编：518057；<br></p>
      <p>我们将尽快审核所涉问题，并在验证你的用户身份后的十五天内予以回复。</p>
      <div id="cn_truste"><a href="//privacy.truste.com/privacy-seal/validation?rid=b2cd33d4-c054-4ff8-9e01-9ac8ba59acfd&amp;lang=zh-cn"
           target="_blank"><img style="border: none"
               src="//privacy-policy.truste.com/privacy-seal/seal?rid=b2cd33d4-c054-4ff8-9e01-9ac8ba59acfd"
               alt="TRUSTe"></a></div>
      <p style="text-align:right"><b>深圳市腾讯计算机系统有限公司</b></p>
    </div>
    <div class="catalog-wrp">
      <div class="catalog"
           style="max-width: 219px;">
        <div class="catalog-item"><a class="catalog-link current"
             data-index="0"
             href="#导言">导言</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="1"
             href="#1我们收集、使用的信息">1.我们收集、使用的信息</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="2"
             href="#2信息的存储">2.信息的存储</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="3"
             href="#3信息安全">3.信息安全</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="4"
             href="#4信息共享">4.信息共享</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="5"
             href="#5你的权利">5.你的权利</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="6"
             href="#6变更">6.变更</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="7"
             href="#7未成年人保护">7.未成年人保护</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="8"
             href="#8其他">8.其他</a></div>
        <div class="catalog-item"><a class="catalog-link"
             data-index="9"
             href="#9联系我们">9.联系我们</a></div>
        <div class="catalog-index"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
      list: [],
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    handleSelectChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        welcome: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,  //动态设置其他选项值
      });
    },
  },
};
</script>
<style>
body,
h1,
h2,
h3,
li,
ul {
  padding: 0;
  margin: 0;
}
li,
ul {
  list-style: none;
  margin: 0;
}
body,
html {
  height: 100%;
}
html {
  scroll-behavior: smooth;
}
body {
  font: 14px/1.6 -apple-system-font, BlinkMacSystemFont, Helvetica Neue,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial,
    sans-serif;
}
a {
  text-decoration: none;
  color: #66799f;
}
.wrap {
  min-height: 100%;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
}
.upgrade__notice {
  line-height: 48px;
  background-color: #ededed;
  font-size: 15px;
  display: none;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
}
.post .footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  background-color: transparent;
}
.post .footer:before {
  content: "";
  display: block;
  border-top: 1px solid #d9d9d9;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: scaleY(0.5);
  transform-origin: left top;
}
.head,
.head-container {
  height: 54px;
}
.head {
  position: fixed;
  top: 0;
  background-color: #2aae67;
  display: flex;
  align-items: center;
  padding: 0 32px;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
}
.logo {
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 26px;
  background-size: cover;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='31.902' height='26' viewBox='0 0 31.902 26'%3E  %3Cdefs%3E    %3Cpath id='325f07a2-da64-467b-82ae-c347325b6a72-a' d='M0 0h22.764v20.507H0z'/%3E  %3C/defs%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cmask id='325f07a2-da64-467b-82ae-c347325b6a72-b' fill='%23fff'%3E      %3Cuse xlink:href='%23325f07a2-da64-467b-82ae-c347325b6a72-a'/%3E    %3C/mask%3E    %3Cpath fill='%23FFF' d='M11.53 0C5.163 0 0 4.336 0 9.685c0 2.918 1.553 5.545 3.984 7.32a.776.776 0 0 1 .282.879l-.52 1.953c-.023.092-.061.187-.061.283 0 .214.172.387.384.387.084 0 .152-.03.222-.072l2.525-1.469c.19-.11.39-.178.612-.178.118 0 .231.018.339.051a13.539 13.539 0 0 0 4.397.516 7.514 7.514 0 0 1-.387-2.374c0-4.878 4.708-8.833 10.516-8.833.21 0 .264.007.471.017C21.896 3.538 17.284 0 11.531 0M7.688 7.96a1.369 1.369 0 0 1-1.364-1.374c0-.76.61-1.374 1.364-1.374.752 0 1.362.615 1.362 1.374 0 .758-.61 1.374-1.362 1.374m7.686 0a1.369 1.369 0 0 1-1.363-1.374c0-.76.61-1.374 1.363-1.374s1.364.615 1.364 1.374c0 .758-.61 1.373-1.364 1.373' mask='url(%23325f07a2-da64-467b-82ae-c347325b6a72-b)'/%3E    %3Cpath fill='%23FFF' d='M28.582 23.081c2.025-1.48 3.32-3.668 3.32-6.1 0-4.458-4.302-8.07-9.61-8.07-5.306 0-9.608 3.612-9.608 8.07s4.302 8.071 9.609 8.071c1.096 0 2.155-.158 3.136-.442a.96.96 0 0 1 .283-.043c.184 0 .352.057.51.149l2.103 1.224c.06.034.116.06.186.06.177 0 .32-.145.32-.323 0-.08-.032-.16-.052-.236-.012-.046-.27-1.02-.433-1.628a.647.647 0 0 1 .235-.732m-9.491-7.474c-.663 0-1.2-.54-1.2-1.208 0-.668.537-1.21 1.2-1.21.662 0 1.2.542 1.2 1.21 0 .667-.538 1.208-1.2 1.208m6.406 0c-.663 0-1.2-.54-1.2-1.208 0-.668.537-1.21 1.2-1.21.663 0 1.2.542 1.2 1.21 0 .667-.537 1.208-1.2 1.208'/%3E  %3C/g%3E%3C/svg%3E");
  margin-right: 32px;
  flex-shrink: 0;
  opacity: 0.9;
}
.nav {
  display: flex;
  font-size: 16px;
  align-items: center;
  flex: 1;
  overflow: hidden;
}
.nav a {
  color: #fff;
  line-height: 54px;
  white-space: nowrap;
  display: block;
  color: hsla(0, 0%, 100%, 0.8);
  margin-right: 24px;
}
.nav a:hover {
  transition: color 0.3s;
  color: #fff;
}
.lang_change {
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
}
.lang_change a {
  padding: 0 8px;
  color: hsla(0, 0%, 100%, 0.7);
}
.lang_change a:hover {
  transition: color 0.3s;
  color: #fff;
}
.lang_change a + a {
  border-left: 1px solid hsla(0, 0%, 100%, 0.3);
}
.lang_change a.current {
  color: #fff;
}
.container {
  background-color: #fff;
}
.content {
  padding: 96px 164px;
  max-width: 1123px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
  font-size: 17px;
}
.content .sub_title {
  padding: 21px 0;
  font-size: 18px;
  font-weight: 400;
}
.content h2 {
  font-size: 20px;
  font-weight: 700;
  padding-top: 144px;
  margin-top: -80px;
}
.content h2:first-child {
  padding-top: 80px;
}
.content p {
  margin: 24px 0;
}
.content p + h2 {
  padding-top: 120px;
}
.content strong {
  font-weight: 700;
}
.content table {
  width: 100%;
  border-collapse: collapse;
  margin: 24px 0;
}
.content td {
  border-bottom: 1px solid #e3e4e5;
}
.content td,
.content th {
  padding: 17px 24px;
  line-height: 1.4;
}
.content th {
  background-color: #f6f7f8;
  color: #7e8081;
  font-weight: 400;
}
@media (prefers-color-scheme: dark) {
  .h5 .content th {
    background-color: hsla(0, 0%, 100%, 0.05);
  }
  .h5 .content td {
    border-color: hsla(0, 0%, 100%, 0.05);
  }
}
.iframe.show {
  opacity: 1;
  transform: translateY(0);
}
.iframe {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s, transform 0.5s;
}
.iframe .wrap {
  min-width: 0;
  background-color: #fff;
}
.iframe .footer {
  max-width: 1120px;
  padding: 40px 88px 30px;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
}
.iframe .footer:before {
  left: 88px;
  right: 88px;
}
.iframe .content {
  padding: 96px 88px;
  box-sizing: content-box;
  max-width: 768px;
}
body.h5.iframe,
body.h5.iframe .content {
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.9);
}
body.h5.iframe .content img,
body.h5.iframe img {
  max-width: 100% !important;
}
.content img {
  max-width: 100%;
}
.content_title {
  padding-bottom: 64px;
  font-size: 32px;
  line-height: 50px;
  font-weight: 500;
}
.content_body {
  text-align: justify;
}
.content_body p:first-child {
  margin-top: 0;
}
.content_body ol ol {
  padding-left: 25px;
}
.docs_img_wrp {
  text-align: center;
}
.em_text {
  font-style: normal;
  font-weight: 700;
}
.sign {
  text-align: right;
}
.dos {
  font-size: 7px;
  display: inline-block;
  vertical-align: 3px;
  margin-right: 3px;
}
.article {
  margin-bottom: 2em;
}
#js_content {
  position: relative;
}
.catalog-wrp {
  position: absolute;
  left: 100%;
  right: 48px;
}
.catalog {
  position: fixed;
  top: 150px;
  margin-left: 48px;
  padding-left: 16px;
  border-left: 2px solid rgba(0, 0, 0, 0.05);
}
.catalog-index {
  position: absolute;
  left: -2px;
  border-left: 2px solid #07c160;
  height: 36px;
  top: 0;
  transition: top 0.2s;
}
.catalog-item:first-child .catalog-link {
  padding-top: 0;
}
.catalog-item:last-child .catalog-link {
  padding-bottom: 0;
}
.catalog-item .catalog-link {
  padding: 6px 0;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.9);
  font-size: 15px;
}
.catalog-item .catalog-link.current {
  color: #07c160;
}
@media (max-width: 1024px) {
  .catalog {
    display: none;
  }

  .wrap {
    background: none;
    min-width: 0;
    padding-bottom: 0;
  }
  .head {
    min-width: 0;
    justify-content: space-between;
    padding: 0 24px;
  }
  .head .nav {
    display: none;
  }
  .logo {
    width: 27px;
    height: 22px;
  }
  .container {
    width: auto;
    margin: 0;
    padding: 0;
    background-color: transparent;
  }
  .content {
    box-sizing: content-box;
    padding: 96px 88px;
  }
  .catalog-wrp {
    display: none;
  }
  .nav {
    visibility: hidden;
  }
  p {
    padding: 0 0 10px;
    margin: 0;
  }
  img.docs_img {
    max-width: 100%;
  }
  a {
    word-break: break-all;
    color: #66799f;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
  .dos {
    color: #999;
  }
  dd {
    margin-left: 10px;
  }
}
@media (max-width: 1024px) and (max-width: 450px) {
  .lang_change {
    visibility: hidden;
  }
}
@media (max-width: 600px) {
  .content,
  .iframe .content {
    max-width: 100%;
    background: none;
    padding: 64px 24px;
    margin: 0;
    border: none;
    border-radius: 0;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
  }
  .iframe .footer {
    padding-left: 24px;
    padding-right: 24px;
  }
  .iframe .footer:before {
    left: 24px;
    right: 24px;
  }
}
.h5:not(.iframe) .content {
  padding: 24px;
}
@media (prefers-color-scheme: dark) {
  body.h5 {
    color: hsla(0, 0%, 100%, 0.8);
  }
  body.h5,
  body.h5 .content {
    background-color: #191919;
  }
  body.h5 a {
    color: #7d90a9;
  }
}
.footer-wrp {
  height: 115px;
}
.footer {
  position: absolute;
  text-align: center;
  color: hsla(0, 0%, 100%, 0.7);
  background-color: #fff;
  padding: 40px 0 32px;
  width: 100%;
  bottom: 0;
}
.footer__bd {
  line-height: 1;
}
.footer__links {
  display: inline-flex;
  font-size: 13px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  padding: 0 24px;
  justify-content: center;
  line-height: 1.6;
}
.footer a {
  margin: 0 8px;
}
.footer a:link,
.footer a:visited {
  color: rgba(0, 0, 0, 0.7);
  text-decoration: none;
}
.footer a:hover {
  color: rgba(0, 0, 0, 0.7);
  text-decoration: underline;
}
.footer__copyright {
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
  margin-top: 8px;
  font-weight: 500;
}
.graytext {
  color: rgba(0, 0, 0, 0.7);
}
</style>